import React from 'react'
// components
import { Modal } from 'components/UI'
import { Slide } from '@mui/material'

export const Transition = React.forwardRef((props, ref) => <Slide direction='up' {...props} ref={ref} />)

const style = {
  modal: { maxHeight: '100%', zIndex: 1300 },
  backdrop: { position: 'absolute' }
}

const FullModalContainer = ({ children, hideModal, isOpen, width }) => {
  return (
    <Modal
      fullScreen
      width={width}
      isOpen={isOpen}
      style={style.modal}
      hideModal={hideModal}
      TransitionComponent={Transition}
      BackdropProps={{ style: style.backdrop }}
    >
      {children}
    </Modal>
  )
}

export default FullModalContainer
